var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("form", [
    _c(
      "div",
      { staticClass: "w-full py-4" },
      [
        _c("form-item", { attrs: { label: "Note" } }, [
          _c(
            "div",
            { staticClass: "relative" },
            [
              _c("TextArea", {
                attrs: {
                  placeholder: "Note for Rejection",
                  error:
                    _vm.$v.input.note.$dirty &&
                    (!_vm.$v.input.note.required ||
                      !_vm.$v.input.note.maxLength),
                  maxlength: 255
                },
                model: {
                  value: _vm.input.note,
                  callback: function($$v) {
                    _vm.$set(_vm.input, "note", $$v)
                  },
                  expression: "input.note"
                }
              }),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "absolute right-0 text-xs",
                  staticStyle: { bottom: "15px", right: "15px" }
                },
                [_vm._v(_vm._s(_vm.input.note.length) + "/255")]
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "flex flex-col pt-2" },
            [
              _vm.$v.input.note.$dirty && !_vm.$v.input.note.required
                ? _c("text-error", {
                    attrs: { text: "Please fill the Description." }
                  })
                : _vm._e(),
              _vm._v(" "),
              _vm.$v.input.note.$dirty && !_vm.$v.input.note.maxLength
                ? _c("text-error", {
                    attrs: {
                      text: "Max length description channel is 1000 character"
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3a2720b2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a2720b2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/contents/RejectionForm.vue
// module id = null
// module chunks = 